import Img01 from "./Images/01.png";
import Img02 from "./Images/02.png";
import Img03 from "./Images/03.png";
import Img04 from "./Images/04.png";
import Img05 from "./Images/05.png";
import Img06 from "./Images/06.png";
import Img07 from "./Images/07.png";
import Img08 from "./Images/08.png";
import Img09 from "./Images/09.png";
import Img10 from "./Images/10.png";
import Img11 from "./Images/11.png";
import Img12 from "./Images/12.png";
import Img13 from "./Images/13.png";
import Img14 from "./Images/14.png";
import Img15 from "./Images/15.png";
import Img16 from "./Images/16.png";
import Img17 from "./Images/17.png";
import Img18 from "./Images/18.png";

const imagesArray = [
    Img01,
    Img02,
    Img03,
    Img04,
    Img05,
    Img06,
    Img07,
    Img08,
    Img09,
    Img10,
    Img11,
    Img12,
    Img13,
    Img14,
    Img15,
    Img16,
    Img17,
    Img18,
];

export default imagesArray;
